export enum Routes {
    TASK_MANAGER_TEMPLATE_VIEW = 'task-manager/templates/view',
    CONNECT_HOME_PAGE = '/en/connect',
    INVATLID_TEMPLATE = 'task-manager/templates/notFound'
}